export const comments = {
    namespaced: true,
    state: {
        addComment: { user: null, status: null, type: null },
        removeComment: { user: null, status: null, type: null }
    },

    getters: {
        onAddComment(state) {
            return state.addComment;
        },
        onRemoveComment(state) {
            return state.removeComment;
        }
    },

    mutations: {
        DISPATCHER_ADD_COMMENT(state, obj) {
            state.addComment = obj;
        },
        DISPATCHER_REMOVE_COMMENT(state, obj) {
            state.removeComment = obj;
        }
    },

    actions: {
        dispatcherAddComment(context, obj) {
            context.commit("DISPATCHER_ADD_COMMENT", obj);
        },
        dispatcherRemoveComment(context, obj) {
            context.commit("DISPATCHER_REMOVE_COMMENT", obj);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/events/comments.js